import wixWindow from 'wix-window';
import wixAnimations from 'wix-animations';

const infinity_rotation_timeline = wixAnimations.timeline({ repeat: -1 });
$w.onReady(function () {
    initRotationAnimation();
});

function initRotationAnimation() {
    const element_to_rotate = $w('#welcometoour,#spikeyworld2,#inviteyou,#inviteyou2');

    infinity_rotation_timeline.add(element_to_rotate, { rotate: 360, duration: 5000, easing: 'easeLinear' }).play();
}